// extracted by mini-css-extract-plugin
export var buttonContent = "_2c-0";
export var centered = "_2c-1";
export var centeredFlex = "_2c-2";
export var errorText = "_2c-3";
export var icon = "_2c-4";
export var iconButtonContent = "_2c-5";
export var monospace = "_2c-6";
export var padded = "_2c-7";